export interface QueryStringFilter {
	(uri:string, params?:Object):string;
}

export function QueryStringUriFilter():QueryStringFilter{
	return function(uri:string, params:Object = {}){
		if(!angular.isDefined(uri) || uri === null || uri.length < 1){
			return '';
		}
		
		if(Object.keys(params).length < 1){
			return uri;
		}
		
		let parts = uri.split('?');
		uri = parts[0];
		let queryString = parts[1] || '';
		if(queryString.length > 0){
			queryString += '&';
		}

		// generate string from params supplied to the filter
		queryString += Object.keys(params).map(key => {
			let value = params[key];
			let qsParam = '';
			
			if(angular.isArray(value)){
				qsParam = value.map(v => `${key}=${v}`).join('&');
			} else {
				qsParam = `${key}=${value}`;
			}
			
			return qsParam;
		}).join('&');

		return `${uri}?${queryString}`;
	};
}


// WEBPACK FOOTER //
// ./src/phoenix/filters/queryStringUri.ts